import { render, staticRenderFns } from "./Pagination-New.vue?vue&type=template&id=04f5bcef&"
import script from "./Pagination-New.vue?vue&type=script&lang=js&"
export * from "./Pagination-New.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports